import NamespacedSerializer from '@linc-technologies/linced-common/serializers/namespaced';

// Base maps `events/x` model names to the `x` payload keys of the events
// service.
export default class Base extends NamespacedSerializer {
  namespace = 'events';
}
